module.exports = __webpack_public_path__ + "img/202407_03.0eb7538d.jpg";